import { PaymentMethods } from 'features/deposit/interface';

const playerProfileApiWrapper = (requests: any) => {
	return {
		getPlayerProfileAvatars: () => {
			return requests.get(`player-profiles/avatars`);
		},

		updatePlayerProfileAvatar: (avatarId: number) => {
			return requests.put(`player-profiles/avatars/${avatarId}`);
		},

		getMedals: () => {
			return requests.get(`player-profiles/medals`);
		},

		claimMedal: (medalId: string) => {
			return requests.put(`player-profiles/medals/${medalId}`);
		},

		updateLastPaymentMethod: (method: PaymentMethods, bankId: number | null) => {
			const requestBody: any = {
				lastDepositMethod: method,
			};
			if (bankId) {
				requestBody.lastDepositBankId = bankId;
			}

			return requests.put(`player-profiles`, requestBody);
		},
	};
};

export default playerProfileApiWrapper;
